import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link,Redirect,useHistory  } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";

import { Tooltip } from "@material-ui/core";  
import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import { Formik } from "formik";
import { Table } from "react-bootstrap";
import CodeExample from "../../partials/content/CodeExample";
import { createPatient,getFields,getAccountDetails,getAccounts,getLocations,getPentityByKey,getProcedureTypes, retrieve,updateMaster,getMyProfile,s3UploadWithOptions,getPatientById,createSchedule,getUsersWoP,getRoles,getMyAccounts, getMaster,getTemplates, signedUrl,s3Upload,addFile,getFile } from "../../crud/auth.crud";
import FileUploadPreview from './FileUploadPreview';

import 'date-fns';
import Grid from '@material-ui/core/Grid';
 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import 'react-dropzone-uploader/dist/styles.css'
import Dropzone from 'react-dropzone-uploader'
import { Figure } from "react-bootstrap";
import S3Image from "../../widgets/S3Image";
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import {  format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  
  KeyboardDatePicker,
} from '@material-ui/pickers';

import {Recorder} from 'react-voice-recorder'
import ReactAudioPlayer from 'react-audio-player';
import './voice.css'
import AudiotrackIcon from '@material-ui/icons/Audiotrack';
import Draggable from 'react-draggable';

import { ReactMediaRecorder } from "react-media-recorder";
import CircularProgress from '@material-ui/core/CircularProgress';


import MusicVideoIcon from '@material-ui/icons/MusicVideo';

import StopIcon from '@material-ui/icons/Stop';

import AddTemplateData from './AddTemplateData';

import ViewTemplateData from './ViewTemplateData';

import CreateJobRequest from "./CreateJobRequest";

import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';


import { createJobRequest,getMenus,getJobServiceTypes,getLabAccounts} from "../../crud/auth.crud";
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormHelperText from '@material-ui/core/FormHelperText';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class CreatePatient extends React.Component {

  state = {
    fields:[],
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    redirect:false,
    //patients:[{firstName:"",lastName:"",middleName:"",dateOfBirth:null,mobile:"",secondaryMobile:"",email:"",gender:""}],
    patients:[],
    pentity:{},
    templates:[],
    roles:[],
    users:[],
    accounts:[],
    tasktypes:[],
    permission:[],
    patient:null,
    dob:null,
    type:'none',
    currentUser:[],
    procedureTypes:[],
    duplicatePatients:[],
    patientLoading:false,
    patientSelected:false,
    addTemplateOpen:false,
    viewTemplateOpen:false,
    audioDetails : {
url: null,
blob: null,
chunks: null,
duration: {
h: null,
m: null,
s: null,
}
},
videoOpen:false,
videoRecord:false,
videoDetails:false,
uploadComplete:false,
addtemTemplate:null,
addtemPatient:null,
addtemFromPath:null,
viewtemTemplate:null,
viewtemPatient:null,
patientType: null,
 jobServiceTypes:[],
      jobServiceTypeId:[],
      assignedToAccountKey:null,
      deliveryDate:null,
      labAccounts:[],
      patientType:'regular',
      redirect:false,
      search:null,
      treatmentPlans:[],
      selectedPlan:[],
       selTreatmentPlans:[],
        implants:[],
         locations:[],
      treatmentPlans:[],
      statusMap:{},
      fieldGroups: [
      {
        "fieldName": "extractions1",
        "displayName": "Top",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "top",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16"
        ],
        "items": null,
        "imagePath": [
          "media/misc/etop1.png",
          "media/misc/etop2.png",
          "media/misc/etop3.png",
          "media/misc/etop4.png",
          "media/misc/etop5.png",
          "media/misc/etop6.png",
          "media/misc/etop7.png",
          "media/misc/etop8.png",
          "media/misc/etop9.png",
          "media/misc/etop10.png",
          "media/misc/etop11.png",
          "media/misc/etop12.png",
          "media/misc/etop13.png",
          "media/misc/etop14.png",
          "media/misc/etop15.png",
          "media/misc/etop16.png"
        ],
        "lookUp": null
      },
      {
        "fieldName": "extractions2",
        "displayName": "Bottom",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "bottom",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "32",
          "31",
          "30",
          "29",
          "28",
          "27",
          "26",
          "25",
          "24",
          "23",
          "22",
          "21",
          "20",
          "19",
          "18",
          "17"
        ],
        "items": null,
        "imagePath": [
          "media/misc/ebottom32.png",
          "media/misc/ebottom31.png",
          "media/misc/ebottom30.png",
          "media/misc/ebottom29.png",
          "media/misc/ebottom28.png",
          "media/misc/ebottom27.png",
          "media/misc/ebottom26.png",
          "media/misc/ebottom25.png",
          "media/misc/ebottom24.png",
          "media/misc/ebottom23.png",
          "media/misc/ebottom22.png",
          "media/misc/ebottom21.png",
          "media/misc/ebottom20.png",
          "media/misc/ebottom19.png",
          "media/misc/ebottom18.png",
          "media/misc/ebottom17.png"
        ],
        "lookUp": null
      }
    ]
  }


onSelectTag=(e, value)=> {
console.log("implant:::",value);
let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.implantTypeKey)
      ))
    console.log(tguser);
    this.setState({implantTypes:tguser});
  }
}


onSelectPlan=(e, value)=> {
console.log("trearment plan:::",value);
let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.treatmentPlanKey)
      ))
    console.log(tguser);
    this.setState({selTreatmentPlans:tguser});
  }
}


  handleCheckBoxChange = event => {

	console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
	//console.log(event);
	let chk = this.state[event.currentTarget.name];
	let chkvalue=[];
	if(chk!=null)
	{
		chk.push(event.currentTarget.value);
	}
	else
	{
		chk = [event.currentTarget.value];
	}
	this.setState({
		[event.currentTarget.name] : chk
	})
}
  
handleServiceChange = event => {

	console.log(event.currentTarget.name + "---"+ event.currentTarget.value);
	//console.log(event);
	let chk = this.state.jobServiceTypeId;
	let chkvalue=[];
	if(chk!=null)
	{
		chk.push(event.currentTarget.value);
	}
	else
	{
		chk = [event.currentTarget.value];
	}
	this.setState({
		jobServiceTypeId : chk
	})
  //console.log("checkbox::::::",chk);
}


 handleAccountChange = (event,newValue) =>
  {
       console.log("account chnage::::",event,newValue);
       if(newValue!=null && newValue.accountId!=null)
          this.setState({assignedToAccountKey:newValue.accountId});
       
 
  }

  handleDateChange = (date: Date | null) => {
    this.setState({selDate:date});
  };

  handleZipChange = (e) => {

    const {setFieldValue} = this.props;
    //console.log(e.target.name);
    //console.log(e.target.value);

    setFieldValue("country", "USA");
    setFieldValue("state", "MA");
    setFieldValue("city", "Boston");
  };

  

  addTemplate=(template,pentity)=>
  {
    this.setState({addtemTemplate:template,
      addtemPatient:pentity,addTemplateOpen:true});
  }
  viewTemplate=(template,pentity)=>
  {
    this.setState({viewtemTemplate:template,
      viewtemPatient:pentity,viewTemplateOpen:true});
  }
  handleOpen = () =>
  {
    if(this.state.pentity != null)
    {
      this.setState({open:true});
    }
    else      
    {
      this.setState({type:'document'});
      this.pform.handleSubmit();
    }
    
  }

    accountChange = (e) =>
 {
      console.log("account chnage::::",e);

      getLocations(1,100,'locationName','asc',{accountKey:e.target.value})
      .then((response) => {
        this.setState({ locations:response.data})
        //console.log("patient by id::::",data);
       });
      

      //const response = await getLocations()
      //console.log("lcation:::::",response);
      //setLocations(response.data);
 }
 
 videoClose = () =>
  {
    this.setState({videoOpen:false});
  }

  vRecordClose = () =>
  {
	  this.setState({videoRecord:false});
  }
  async send()
  {
   //console.log("sedn cloik");
    if(this.state.pentity != null)
    {
      //console.log("tform submit");
      this.tform.handleSubmit();
    }
    else      
    {
      this.setState({loading:true});
      await this.pform.handleSubmit();
       setTimeout(()=> {
        this.tform.handleSubmit();
        //console.log("wait 3 seconds");
      }, 3000);
      //await this.tform.handleSubmit();
      this.setState({loading:false});
    }
  }

constructor(props)
{
  super(props);
  var date = new Date();
    this.state = {
      menu: false,
      fields:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
      redirect:false,
      //patients:[{firstName:"",lastName:"",middleName:"",dateOfBirth:null,mobile:"",secondaryMobile:"",email:"",gender:""}],
      patients:[],
      pentity:null,
      templates:[],
      schdate: date,
      tasktypes:[],
      permission:[],
      roles:[],
      users:[],
      accounts:[],
      patient: null,
      dob:null,
      type:'none',
      currentUser:[],
      procedureTypes:[],
      duplicatePatients:[],
      locations:[],
      patientLoading:false,
       patientSelected:false,
       addTemplateOpen:false,
       viewTemplateOpen:false,
      audioDetails : {
url: null,
blob: null,
chunks: null,
duration: {
h: null,
m: null,
s: null,
}
},
videoOpen:false,
videoRecord:false,
videoDetails:false,
uploadComplete:false,
addtemTemplate:null,
addtemPatient:null,
addtemFromPath:null,
viewtemPatient:null,
viewtemTemplate:null,
 jobServiceTypes:[],
      jobServiceTypeId:[],
      assignedToAccountKey:null,
      deliveryDate:null,
      labAccounts:[],
      patientType:'regular',
      redirect:false,
      search:null,
      treatmentPlans:[],
      selectedPlan:[],
       selTreatmentPlans:[],
        implants:[],
         locations:[],
      treatmentPlans:[],
      statusMap:{},
      fieldGroups: [
      {
        "fieldName": "extractions1",
        "displayName": "Top",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "top",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "1",
          "2",
          "3",
          "4",
          "5",
          "6",
          "7",
          "8",
          "9",
          "10",
          "11",
          "12",
          "13",
          "14",
          "15",
          "16"
        ],
        "items": null,
        "imagePath": [
          "media/misc/etop1.png",
          "media/misc/etop2.png",
          "media/misc/etop3.png",
          "media/misc/etop4.png",
          "media/misc/etop5.png",
          "media/misc/etop6.png",
          "media/misc/etop7.png",
          "media/misc/etop8.png",
          "media/misc/etop9.png",
          "media/misc/etop10.png",
          "media/misc/etop11.png",
          "media/misc/etop12.png",
          "media/misc/etop13.png",
          "media/misc/etop14.png",
          "media/misc/etop15.png",
          "media/misc/etop16.png"
        ],
        "lookUp": null
      },
      {
        "fieldName": "extractions2",
        "displayName": "Bottom",
        "dataType": "checkboxgroupimage",
        "isMandatory": null,
        "isDummy": false,
        "imagePosition": "bottom",
        "background": null,
        "bottomImage": null,
        "length": null,
        "values": [
          "32",
          "31",
          "30",
          "29",
          "28",
          "27",
          "26",
          "25",
          "24",
          "23",
          "22",
          "21",
          "20",
          "19",
          "18",
          "17"
        ],
        "items": null,
        "imagePath": [
          "media/misc/ebottom32.png",
          "media/misc/ebottom31.png",
          "media/misc/ebottom30.png",
          "media/misc/ebottom29.png",
          "media/misc/ebottom28.png",
          "media/misc/ebottom27.png",
          "media/misc/ebottom26.png",
          "media/misc/ebottom25.png",
          "media/misc/ebottom24.png",
          "media/misc/ebottom23.png",
          "media/misc/ebottom22.png",
          "media/misc/ebottom21.png",
          "media/misc/ebottom20.png",
          "media/misc/ebottom19.png",
          "media/misc/ebottom18.png",
          "media/misc/ebottom17.png"
        ],
        "lookUp": null
      }
    ]
    };


    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
  this.send = this.send.bind(this);
}
  getSignedUrl = (file, callback) =>
  {
    //this.setState({open:true});
    //console.log("getSignedUrl");
    const params = {
    objectName: file.name,
    contentType: file.type
  };
    //console.log(params);
    signedUrl({ params })
    .then(data => {
      //callback(data.data);
      //console.log(data.data);
     // s3Upload(data.data.signedUrl,file,{headers:{'x-amz-acl': 'public-read','Content-Type' : params.contentType}})
      s3Upload(data.data.signedUrl,file)
      .then(response => response.data)
        .then((data) => {
         
            //console.log(data);
         });
    })
    .catch(error => {
      //console.log(error);
    });

}

handleAudioStop(data)
{
  console.log(data)
  this.setState({ audioDetails: data });
}
async handleAudioUpload(file) {
  console.log(file);
  if(file!=null && file.type!=null && this.state.patient!=null)
  {
    console.log(this.state.patient.id);
    let id = this.state.patient.id;
    let url ="";
    let name = format(new Date(),"MM-dd-yyyy-HH-mm") + ".mp3"
       await signedUrl({ name,id })
      .then(data => {
        url = data.data.signedUrl;
        var options = {
          headers: {
            'Content-Type': file.type
          }
        };

        s3UploadWithOptions(url, file, options)
        .then((resp) =>
        {
          addFile(id,name,file.size,file.type,this.state.id).then(response => response.data)
          .then((data) => {
              getPatientById(id).then(response => response.data)
            .then((data) => {
              const reset = {
              url: null,
              blob: null,
              chunks: null,
              duration: {
                h: null,
                m: null,
                s: null,
              }
            }

              this.setState({ patients: data,audioDetails: reset })
              //console.log(data);
             });
          });
        })
        
      })
  }
    
}
handleRest()
{
  const reset = {
    url: null,
    blob: null,
    chunks: null,
    duration: {
      h: null,
      m: null,
      s: null,
    }
  }
this.setState({ audioDetails: reset });
}

getUploadParams = async  ({ file, meta: { name } }) => {

  //console.log(this.state.patient.id);
  let id = this.state.patient.id;
  let url ="";
     await signedUrl({ name,id })
    .then(data => {
      url = data.data.signedUrl;
      
    })
    //console.log("url 2===="+url);
    //console.log("url===="+ url);
    //console.log(file);
    return { body: file, meta: {}, url:  url,method:'PUT'}
  }

   handleSubmit = (files, allFiles) => {
    //console.log(files.map(f => f.meta))
    //allFiles.forEach(f => f.remove())
    //console.log('here');
    //files.map((f) => (
        //console.log(f.meta)
      //))
  }

  imageClose = () =>
  {
    this.setState({imageOpen:false});
  }

  /*imageView = (id,originalFileKey) => {
    this.setState({imageUrl:'media/misc/loading.gif',imageOpen:true});
    getFile(id,originalFileKey).then(response => response.data)
        .then((data) => {
          this.setState({imageUrl: data.downloadUrl,fileType:})
        });
  }*/

  imageView = (id,previewFileKey,fileKey,originalFileKey,fileType) => {
    console.log("filekey",fileKey);

    var url='';

    if(fileType.includes("image"))
  {
    /*getFileAnnotation(fileKey).then(response => response.data)
          .then((data) => {
            if(data!=null && data[0]!=null && data[0].annotations!=null)
            {
            this.setState({annotations: data[0].annotations.annotate})
          }
          });
  */
    url=previewFileKey;

  }
  else
  {
    url=originalFileKey;
  }
console.log("fileType::::",fileType);
    this.setState({imageUrl:'media/misc/loading.gif',imageOpen:true,id:fileKey,originalFileKey:url,fileType:fileType});
    getFile(id,url).then(response => response.data)
        .then((data) => {
          this.setState({imageUrl: data.downloadUrl,fileKey:fileKey,status:false,fileType:fileType})
        });
  

  
  }

  videoClose = () =>
  {
    this.setState({videoOpen:false});
  }

  vRecordClose = () =>
  {
	  this.setState({videoRecord:false});
  }

  audioClose = () =>
  {
    this.setState({audioOpen:false});
  }

  addTemplateClose = () =>
  {
    getPentityByKey(this.state.patient.pEntityId).then(response => response.data)
      .then((data) => {
        let patients = [];
        patients.push(data);
        this.setState({ addTemplateOpen:false,pentity:data,patient:data,patients:patients,patientLoading:false,patientSelected:true});
                                 
                         
    })
    
  }

  viewTemplateClose = () =>
  {
    
      this.setState({ viewTemplateOpen:false});
   
    
  }

  audioView = (id,previewFileKey,fileKey,originalFileKey,fileType) => {
    console.log("filekey",fileKey);

  
    getFile(id,originalFileKey).then(response => response.data)
        .then((data) => {
          this.setState({audioUrl: data.downloadUrl,audioKey:fileKey})
        });
  

  
  }

 handleChangeStatus = ({ meta }, status) => {
    //console.log(status, meta)
    const fileId = meta.id;
    let id = this.state.patient.id;
    if(status=="done")
    {

      addFile(id,meta.name,meta.size,meta.type).then(response => response.data)
        .then((data) => {
            getPatientById(id).then(response => response.data)
          .then((data) => {
            this.setState({ patients: data })
            //console.log(data);
                this.setState({
              statusMap: {
                ...this.state.statusMap,
                [fileId]: "verified"
              }
              });
           });
        });
    }
  }
  videoView = (id,previewFileKey,fileKey,originalFileKey,fileType) => {
    console.log("filekey",fileKey);
  
  
    getFile(id,originalFileKey).then(response => response.data)
      .then((data) => {
        this.setState({mediaBlobUrl: data.downloadUrl,videoOpen:true})
      });
    
  
    
  }
  
  toggleMenu(){

    
      if(this.state.pentity != null)
      {
        this.setState({ menu: !this.state.menu })
      }
      else      
      {
        this.setState({type:'template'});
        this.pform.handleSubmit();
        
      }
    
  }
    
selectPatient =(patient) =>
{
  getPentityByKey(patient.pEntityId).then(response => response.data)
  .then((data) => {
    let patients = [];
    patients.push(data);
    this.setState({ pentity:data,patient:data,patients:patients, patientSelected:true,patientLoading:false,duplicateOpen:false});
  });
}

handleClose = () =>
  {
    this.setState({open:false});
  }

duplicateClose = () =>
  {
    this.setState({duplicateOpen:false,patientLoading:false});
  }
  componentDidMount()
  {
    if(this.props.location.data != null)
    {
      getPatientById(this.props.location.data.id).then(response => response.data)
      .then((data) => {
        this.setState({ patients: data,pentity:data[0],patient:data[0],dob:data[0].dateOfBirth,patientSelected:true })
        //console.log("patient by id::::",data);
       });
      }
      else
      {
        this.setState({patients:[{firstName:"",lastName:"",middleName:"",dateOfBirth:null,mobile:"",secondaryMobile:"",email:"",gender:"male"}]})
      }

      getMyProfile().then(response => response.data)
    .then((data) => {
      this.setState({ currentUser: data })
      console.log("currentUser::::",data);
        getMyAccounts().then(response => response.data)
        .then((data) => {
            let accounts =[];
           //this.setState({ accounts: data })
            let currentUser = this.state.currentUser;
            //console.log(this.state.users)
              data.map((acc)=>
                
                  {
                      if(acc.accountId===currentUser[0].accountKey && (acc.businessEntity==='Referral Office' || acc.businessEntity==='Referral Physician' ))
                      {
                          //
                      }
                      else
                      {
                        accounts.push(acc);
                      }
                  }
                  );
                
                this.setState({ accounts: accounts })
           })
     })

    /*getAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts:data })
      //console.log(data[0].fields);
     //console.log(this.state.users)
     })*/

     getTemplates().then(response => response.data)
    .then((data) => {
      this.setState({ templates: data })
      //console.log(data);
     });

      getUsersWoP().then(response => response.data)
    .then((data) => {
      this.setState({ users: data })
      //console.log(this.state.users)
     })

     getRoles().then(response => response.data)
    .then((data) => {
      this.setState({ roles: data })
      //console.log(this.state.users)
     })

       getAccountDetails().then(response => response.data)
                  .then((data) => {
                       console.log("account details::::"+data);
                          getLocations(1,100,'locationName','asc',{accountKey:data.accountId})
                           .then((response) => {
                             //this.setState({ locations:response.data})
                             this.setState({locations:response.data});
                             //console.log("locations:::::",response.data);
                             });
     
                       });
     

      getMaster("implant").then(response => response.data)
               .then((data) => {
                 this.setState({ implants: data })
                 //console.log(this.state.users)
                })
     
                 getMaster("treatmentplan").then(response => response.data)
               .then((data) => {
                 this.setState({ treatmentPlans: data })
                 //console.log(this.state.users)
                })


    getMaster("tasktype").then(response => response.data)
    .then((data) => {
      this.setState({ tasktypes: data })
      //console.log(this.state.users)

     })

    getProcedureTypes().then(response => response.data)
    .then((data) => {
      //this.setState({ procedureTypes: data })
      let filtered=[];
      let procedureTypes =data;
       getAccountDetails().then(response => response.data)
      .then((data) => {
        console.log("prppp::",data);
        if(data.procedureTypes!=null)
        {
          data.procedureTypes.map((pt)=>(
            procedureTypes.filter(x=>x.procedureTypeKey===pt).map((p)=>(
                filtered.push(p)
              ))
            ))
        }
        console.log("filtered prtyy:::::",filtered);
        this.setState({ procedureTypes: filtered })
      //console.log(this.state.users)
      })

      //console.log(this.state.users)
     })

     
         getLabAccounts().then(response => response.data)
         .then((data) => {
           this.setState({ labAccounts: data })
           //console.log(this.state.users)
          })
     
          getJobServiceTypes().then(response => response.data)
          .then((data) => {
            this.setState({jobServiceTypes: data })
            //console.log(this.state.users)
           })
     

     
        
    }

    async uploadVideo(mediaBlobUrl) {
      console.log(mediaBlobUrl);
      let file = mediaBlobUrl;
      if(mediaBlobUrl!=null )
      {
        this.setState({videoDetails:true});
        const config = { responseType: 'blob' };
        axios.get(mediaBlobUrl, config).then(async response => {
    
          let name = "SC-"+format(new Date(),"MM-dd-yyyy-HH-mm") + ".mp4"
          let file = new File([response.data], name,{ type: 'video/mp4' });      
          
          console.log(this.state.patient.id);
          let id = this.state.patient.id;
          let url ="";
          
          await signedUrl({ name,id })
          .then(data => {
            url = data.data.signedUrl;
            var options = {
            headers: {
            'Content-Type': file.type
            }
          };
    
            s3UploadWithOptions(url, file, options)
            .then((resp) =>
            {
              addFile(id,name,file.size,file.type,this.state.id).then(response => response.data)
              .then((data) => {
                  getPatientById(id).then(response => response.data)
                .then((data) => {
                  const reset = {
                  url: null,
                  blob: null,
                  chunks: null,
                  duration: {
                    h: null,
                    m: null,
                    s: null,
                  }
                }
    
                  this.setState({ patients: data,videoDetails:false,uploadComplete:true})
                  //console.log(data);
                 });
              });
            })
             
          })
        });
    
    
        
      }


     getMenus().then(response => response.data)
    .then((data) => {
      
      if(data[0] != null && data[0].permissions !=null)
                {
                 
                  //console.log(data[0].permissions);
                  let perms="";
                  data[0].permissions.map((per) =>(
                    perms = perms + "," + per
                    ))
                  //console.log(perms);
                   this.setState({ permission: perms })

                }
     })
     
  }

  
handleClickDetails(user)
  {
    return function(){
      //console.log('handleClickDetails');
           
    }

    
  
} 



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
     const pentity = this.state.pentity;
     
     //console.log("paint:::",this.state.patients[0],patient);
    return (
      <>

         {this.state.redirect && 
         
            <Redirect 
                     to={{ pathname: "/viewplanner",
                      search: this.state.search}}
                                      />
         
         }

          {this.state.status && (
            <div role="alert" className={"alert "+this.state.statusColor}>
              <div className="alert-text">{this.state.statusMessage}</div>
            </div>
          )}


      

          {this.state.patients!=null && this.state.patients.map((patient)=> (
            <>
            
                <Formik innerRef={p => (this.pform = p)}
                  initialValues={{
                    firstName:patient.firstName,
                    lastName:patient.lastName,
                    middleName:patient.middleName,
                    dateOfBirth:new Date(patient.dateOfBirth),
                    email:patient.email,
                    mobile:patient.mobile,
                    secondaryMobile:patient.secondaryMobile,
                    gender:patient.gender,
                   
                    
                  }}
                  validate={values => {
                    const errors = {};

                    if (values.email) {
                      if (
                      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                    ) {
                      errors.email = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.INVALID_FIELD"
                      });
                    }
                    }

                    if (!values.firstName) {
                      errors.firstName = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.lastName) {
                      errors.lastName = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.mobile) {
                      errors.mobile = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }
                   

                    if (!values.gender) {
                      errors.gender = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!this.state.dob) {
                      errors.dateOfBirth = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                   {/*  if (!values.taskTypeId) {
                      errors.taskTypeId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.accountId) {
                      errors.accountId = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }*/}
                  
                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({patientLoading:true});
                    console.log("patient:::"+Date().toLocaleString());
                   //console.log("create patient step1");
                    createPatient(
                      values.firstName,
                      values.lastName,
                      values.middleName,
                      format(new Date(this.state.dob), 'MM/dd/yyyy'),
                      values.email,
                      values.mobile,
                      values.secondaryMobile,
                      values.address,
                      values.pinCode,
                      values.city,
                      values.state,
                      values.country,
                      values.accountKey,
                      values.gender,
                      
                    )
                      .then(resp => {
                        //props.register(accessToken);

                        //return <Redirect to="/createpatientone" />;
                        //console.log("sdata:::::",resp.data);
                        //this.setState({status:true,
                        //statusMessage:'Patient created successfully',
                        //alertType:'alert-success',loading:false});
                        //window.scrollTo(0,0);
                        //this.setState({ pentity:{},patient:null,patients:[]});

                            console.log("patient create:::::",resp.data.length);
                            if(resp.data.length===1)
                            {
                              if(resp.data[0].isActive===false && resp.data[0].isDeleted ===false)
                              {
                                getPentityByKey(resp.data[0].pEntityId).then(response => response.data)
                                .then((data) => {
                                  let patients = [];
                                  patients.push(data);
                                 //if(this.state.type=='document')
                                 //   {
                                 //     this.setState({ pentity:data,patient:data,patients:patients,open:true,patientLoading:false })
                                 //   }
                                 //  else if(this.state.type=='template')
                                  //  {
                                  //    this.setState({ pentity:data,patient:data,patients:patients,menu: !this.state.menu,patientLoading:false  })
                                  //  }
                                  //  else
                                  //  {
                                      this.setState({ pentity:data,patient:data,patients:patients,patientLoading:false,patientSelected:true});
                                  // }
                                  
                                  //console.log("pentity::::",data);
                                  
                         
                                 })
                              }
                              else
                              {
                                  this.setState({duplicatePatients:resp.data,duplicateOpen:true});
                              }
                            }
                            else
                            {
                                this.setState({duplicatePatients:resp.data,duplicateOpen:true});
                              

                               //return <Redirect to="/createpatient1" />;
                                //let history = useHistory();
                                //history.push('/CreatePatientOne');
                            }
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off" >

                        

                      
        	
                  		<CodeExample beforeCodeTitle="Basic Details">
                    	   <div className="kt-section">
            	        	    <div className="kt-section__content">
                                <div className="row">
                               <div className="col-6">
                                    <InputLabel >Select Workflow</InputLabel>
                                    <Button
        
                                    variant={this.state.patientType!==null && this.state.patientType==='regular'?'contained':'outlined'}
                                    onClick = {()=>this.setState({patientType:"regular"})}
                                    color="primary"
                                    style={{'padding':'10px','margin':'10px'}}
                                    >
                                      Regular Workflow
                                    </Button>

                                    <Button
                                    variant={this.state.patientType!==null && this.state.patientType==='digitalplanning'?'contained':'outlined'}
                                    onClick = {()=>this.setState({patientType:"digitalplanning"})}
                                    color= "primary"
                                    style={{'padding':'10px','margin':'10px'}}
                                    >
                                      Digital Planning
                                    </Button>

                                  </div>
                                  </div>
          		   			          
                 
          		   			          <div className="row">

                                 

                                  <div className="col-6">
                                    <TextField
                                      margin="normal"
                                      label="First Name"
                                      className="kt-width-full"
                                      name="firstName"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.firstName}
                                      helperText={touched.firstName && errors.firstName}
                                      error={Boolean(touched.firstName && errors.firstName)}
                                    />
                                  </div>        

                                  <div className="col-6">
                                    <TextField
                                      margin="normal"
                                      label="Middle Name"
                                      className="kt-width-full"
                                      name="middleName"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.middleName}
                                      helperText={touched.middleName && errors.middleName}
                                      error={Boolean(touched.middleName && errors.middleName)}
                                    />
                                  </div>      

                                  <div className="col-6">
                                    <TextField
                                      margin="normal"
                                      label="Last Name"
                                      className="kt-width-full"
                                      name="lastName"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.lastName}
                                      helperText={touched.lastName && errors.lastName}
                                      error={Boolean(touched.lastName && errors.lastName)}
                                    />
                                  </div>

                                  <div className="col-6">
                                 
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container justify="space-around">
                                    <KeyboardDatePicker
                                          variant="inline"
                                          format="MM/dd/yyyy"
                                          margin="normal"
                                          id="dataOfBirth"
                                          name="dataOfBirth"
                                          label="DOB"
                                          maxDate = {new Date()}
                                          value={this.state.dob}
                                          onChange={(value) => this.setState({dob:value})}
                                          helperText={touched.dateOfBirth && errors.dateOfBirth}
                                          error={Boolean(touched.dateOfBirth && errors.dateOfBirth)}
                                             KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                          }}
                                        />
                                    </Grid>
                                    </MuiPickersUtilsProvider>
                                  </div>

                                  

                                  <div className="col-6">
                                    <TextField
                                      label="Email"
                                      margin="normal"
                                      className="kt-width-full"
                                      name="email"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.email}
                                      helperText={touched.email && errors.email}
                                      error={Boolean(touched.email && errors.email)}
                                    />
                                  </div>

                                  <div className="col-6">
                                    <TextField
                                          labelId="gender-label"
                                          id="gender"
                                          margin="normal"
                                          name="gender"
                                          value={values.gender}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          className="kt-width-full"
                                          label="Select Gender"
                                          style={{'width':'100%'}}
                                        select>
                                         
                                          <MenuItem key="male" value="male">Male</MenuItem>
                                          <MenuItem key="female" value="female">Female</MenuItem>
                                          
                                        </TextField>
                                  </div>

                                  <div className="col-6">
                                    <TextField
                                      margin="normal"
                                      label="Mobile"
                                      className="kt-width-full"
                                      name="mobile"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.mobile}
                                      helperText={touched.mobile && errors.mobile}
                                      error={Boolean(
                                        touched.mobile && errors.mobile
                                      )}
                                    />
                                  </div>

                                  <div className="col-6">
                                    <TextField
                                      margin="normal"
                                      label="Secondary Contact"
                                      className="kt-width-full"
                                      name="secondaryMobile"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      value={values.secondaryMobile}
                                      helperText={touched.secondaryMobile && errors.secondaryMobile}
                                      error={Boolean(
                                        touched.secondaryMobile && errors.secondaryMobile
                                      )}
                                    />
                                  </div>
                               
                		   			    </div>
                                <div className="row">
                                  <div className="col">
                                    <button
                                      type="submit"
                                      className={`btn btn-danger btn-elevate kt-login__btn-primary ${clsx(
                                        {
                                          "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.patientLoading
                                        }
                                      )}`}
                             
                                    >

                                       Search Patients
                                    </button>
                                  </div>
                                </div>
				        			    </div>
                		  </div>
                		  </CodeExample>

                     
                    </form>
                    )}
                    </Formik>
              

                      {this.state.patientType!==null && this.state.patientType==="regular" &&
                      <>
                      <div className="row">
                  
                        <div className="col-lg-6">

                            <Formik innerRef={p => (this.tform = p)}
                              initialValues={{
                                accountId:"",
                                roleId:"",
                                userId:"",
                                scheduleType:"",
                                pEntityId:"",
                                startDate: "",
                                endDate:"",
                                notes:"",
                                taskTypeId:"TTP00001",
                             }}
                              validate={values => {
                                const errors = {};

                               

                                if (!values.taskTypeId) {
                                  errors.taskTypeId = this.props.intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                  });
                                }

                                if (!values.accountId) {
                                  errors.accountId = this.props.intl.formatMessage({
                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                  });
                                }

                               

                                return errors;
                              }}
                              onSubmit={(values, { setStatus, setSubmitting }) => {

                    
                                console.log("schedule:::::",Date().toLocaleString());
                                console.log("tform aaaa",this.state.pentity);
                               this.setState({loading:true});
                                createSchedule(
                                  values.accountId,
                                  values.roleId,
                                  values.userId,
                                  "",
                                  this.state.pentity.pEntityId,
                                  this.state.schdate,
                                  values.endDate,
                                  values.notes,
                                  values.taskTypeId,
                                  values.locationKey,
                                  values.procedureTypeKey
                                 
                                  
                                )
                                  .then(resp => {
                                    //props.register(accessToken);
                                    if(this.state.pentity.isActive===false && this.state.pentity.isDeleted===false)
                                    {
                                        let updateObj = {
                                          isActive:true
                                        };

                                        if(values.locationKey!=null && values.locationKey!=undefined) updateObj.locationKey = values.locationKey;
                                        updateMaster('pentityupdate',this.state.pentity.pEntityId,updateObj)
                                        .then((resp) =>{
                                          this.setState({status:true,
                                          statusMessage:'New Patient has been created successfully',
                                          alertType:'alert-success',loading:false,patients:[{firstName:"",lastName:"",middleName:"",dateOfBirth:null,mobile:"",secondaryMobile:"",email:"",gender:"male"}],pentity:{},patient:null});
                                           window.scrollTo(0,0);
                                         });

                                         
                                    }
                                    else if(this.state.pentity.isActive===false && this.state.pentity.isDeleted===true)
                                    {
                                        retrieve(this.state.pentity.id)
                                        .then((response) => {
                                            this.setState({status:true,
                                          statusMessage:'New Patient has been created successfully',
                                          alertType:'alert-success',loading:false,patients:[{firstName:"",lastName:"",middleName:"",dateOfBirth:null,mobile:"",secondaryMobile:"",email:"",gender:"male"}],pentity:{},patient:null});
                                           window.scrollTo(0,0);
                                        
                                        });
                                    }
                                    else
                                    {
                                       this.setState({status:true,
                                          statusMessage:'New Patient has been created successfully',
                                          alertType:'alert-success',loading:false,patients:[{firstName:"",lastName:"",middleName:"",dateOfBirth:null,mobile:"",secondaryMobile:"",email:"",gender:"male"}],pentity:{},patient:null});
                                           window.scrollTo(0,0);
                                         
                                    }

                                   
                                    
                                     
                                  })
                                  .catch(() => {
                                    this.setState({loading:false});
                                  });
                              }}
                            >
                              {({
                                values,
                                status,
                                errors,
                                touched,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                isSubmitting,
                               
                              }) => (
                                <form onSubmit={handleSubmit} noValidate autoComplete="off">
                                  
                             
                            <CodeExample beforeCodeTitle="To Do Details">
                                <div className="kt-section">
                                  <div className="kt-section__content">
                                     <div className="row">
                                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                          <InputLabel id="taskTypeId-label">Select Task Type</InputLabel>
                                             <Select
                                              labelId="taskTypeId-label"
                                              id="taskTypeId"
                                              onChange={handleChange}
                                              margin="normal"
                                              name="taskTypeId"
                                              value={values.taskTypeId}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              className="kt-width-full"
                                              style={{'width':'100%'}}
                                            >
                                            
                                              {this.state.tasktypes.map((ttp) =>(

                                              (this.state.permission.includes("ALLOWEDTYPE:"+ttp.taskTypeId) || ttp.taskTypeId === values.taskTypeId || !this.state.permission.includes("ALLOWEDTYPE"))&& <MenuItem key={ttp.taskTypeId} value={ttp.taskTypeId}>{ttp.taskTypeName}</MenuItem>
                                                 
                                              
                                              ))}
                                            </Select>
                                         </FormControl>
                                      </div>        

                                      <div className="row">
                                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                          <InputLabel id="procedureTypeKey-label">Procedure Type</InputLabel>
                                             <Select
                                              labelId="procedureTypeKey-label"
                                              id="procedureTypeKey"
                                              onChange={handleChange}
                                              margin="normal"
                                              name="procedureTypeKey"
                                              value={values.procedureTypeKey}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              className="kt-width-full"
                                              style={{'width':'100%'}}
                                            >
                                            
                                              {this.state.procedureTypes!=null && this.state.procedureTypes.map((pt) =>(

                                              <MenuItem key={pt.procedureTypeKey} value={pt.procedureTypeKey}>{pt.procedureTypeName}</MenuItem>
                                                 
                                              
                                              ))}
                                            </Select>
                                         </FormControl>
                                      </div> 

                                      <div className="row">
                                       
                                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <Grid container justify="space-around">
                                        <KeyboardDatePicker
                                              variant="inline"
                                              format="MM/dd/yyyy"
                                              margin="normal"
                                              id="startDate"
                                              name="startDate"
                                              label="Task Date"
                                              value={this.state.schdate}
                                              onChange={value => {
                                                this.setState({schdate:value})
                                              }}
                                              KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                              }}
                                            />
                                          
                                        </Grid>
                                        </MuiPickersUtilsProvider>
                                      </div>      

                                     
                                     <div className="row">
                                        <TextField
                                          margin="normal"
                                          label="Notes"
                                          className="kt-width-full"
                                          name="notes"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.notes}
                                          helperText={touched.notes && errors.notes}
                                          error={Boolean(touched.notes && errors.notes)}
                                        />
                                      </div>    
                        
               
                                      <div className="row">
                                         <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                                  <InputLabel id="accountId-label">Assign To</InputLabel>
                                                     <Select
                                                      labelId="accountId-label"
                                                      id="accountId"
                                                      onChange={handleChange}
                                                      margin="normal"
                                                      name="accountId"
                                                      value={values.accountKey}
                                                      onChange={(e) => {handleChange(e);this.accountChange(e);}}
                                                      onBlur={handleBlur}
                                                      className="kt-width-full"
                                                      style={{'width':'100%'}}
                                                      error={Boolean(
                                                        touched.accountId && errors.accountId
                                                      )}
                                                    >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                      </MenuItem>
                                                      {this.state.accounts.map((acc) =>(
                                                      
                                                      <MenuItem key={acc.accountId} value={acc.accountId}>{acc.accountName +' (' + acc.businessEntity +')'}</MenuItem>
                                                      
                                                      ))}
                                                    </Select>
                                                 </FormControl>
                                      </div>
                                      <div className="row">
                                         <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                                  <InputLabel id="locationKey-label">Location</InputLabel>
                                                     <Select
                                                      labelId="locationKey-label"
                                                      id="locationKey"
                                                      onChange={handleChange}
                                                      margin="normal"
                                                      name="locationKey"
                                                      value={values.locationKey}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      className="kt-width-full"
                                                      style={{'width':'100%'}}
                                                      error={Boolean(
                                                        touched.locationKey && errors.locationKey
                                                      )}
                                                    >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                      </MenuItem>
                                                      {this.state.locations.map((loc) =>(
                                                      
                                                      <MenuItem key={loc.locationKey} value={loc.locationKey}>{loc.locationName}</MenuItem>
                                                      
                                                      ))}
                                                    </Select>
                                                 </FormControl>
                                      </div>
                                      {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") && this.state.currentUser.length>0 && values.accountId === this.state.currentUser[0].accountKey &&
                                      <div className="row">
                                        <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                     
                                                  <InputLabel shrink id="roleId-label">Select Role</InputLabel>
                                                     <Select
                                                      labelId="roleId-label"
                                                      id="roleId"
                                                      onChange={handleChange}
                                                      margin="normal"
                                                      name="roleId"
                                                      value={values.roleKey}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      className="kt-width-full"
                                                      style={{'width':'100%'}}
                                                    >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                      </MenuItem>
                                                    {this.state.roles.map((role)=>(
                                                        
                                                        <MenuItem key={role.roleId} value={role.roleId}>{role.roleDescription}</MenuItem>
                                                        
                                                      ))}
                                                    
                                                    

                                                    </Select>
                                                </FormControl>
                                      </div>
                                      )}
                                      {(this.state.permission!=null && !this.state.permission.includes("DENY:TASKASSIGNMENT") && this.state.currentUser.length>0 && values.accountId === this.state.currentUser[0].accountKey &&
                                      <div className="row">
                                             <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                                  <InputLabel id="userId-label">Select User</InputLabel>
                                                     <Select
                                                      labelId="userId-label"
                                                      id="userId"
                                                      onChange={handleChange}
                                                      margin="normal"
                                                      name="userId"
                                                      value={values.userKey}
                                                      onChange={handleChange}
                                                      onBlur={handleBlur}
                                                      className="kt-width-full"
                                                      style={{'width':'100%'}}
                                                    >
                                                    <MenuItem value="">
                                                        <em>None</em>
                                                      </MenuItem>
                                                     {this.state.users.map((user)=>(
                                                       
                                                        <MenuItem key={user.userId} value={user.userId}>{user.firstName + " "+ user.lastName }</MenuItem>
                                                      ))}
                                                    
                                                    

                                                    </Select>
                                                 </FormControl>
                                      </div>
                                      )}

                
                                      </div>
                                      </div>
                                      </CodeExample>
                          
                          </form>
                          )}
                          </Formik>

                        </div>
                  
                        <div className="col-lg-6">
                      
                        
                        
                        <div className="row">
                          <div className="kt-portlet" id="kt_portlet">
                            <div className="kt-portlet__head">
                              <div className="kt-portlet__head-label">
                                {/*<span className="kt-portlet__head-icon">
                                  <i className="flaticon-map-location"></i>
                                </span>*/}
                                
                                <h3 className="kt-portlet__head-title">
                                  Referral Template
                                </h3>
                              </div>
                              <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-group">
                                  <div className="btn-group">
                                    <button type="button" className="btn btn-elevate btn-danger dropdown-toggle" disabled={!this.state.patientSelected} onClick={ this.toggleMenu } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i className="la la-plus"></i> Template Options
                                    </button>
                                    <div className={"dropdown-menu dropdown-menu-right "+ show}>
                                      {this.state.templates !== null && this.state.templates.map((template)=>(
                                        <>
                                      <a className="dropdown-item" href="#" onClick={()=>this.addTemplate(template,pentity)}>
                                      
                                      {template.templateName}</a>
                                        </>
                                      ))}
                                      
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="kt-portlet__body">
                              {patient.templates !=null && patient.templates.filter(x=> x.roleTag===null).length>0 &&
                        <div className="kt-section">
                          <h3>Practice</h3>
                          <div className="kt-section__content">
                            <div className="row">
                            
                            {patient.templates.filter(x=> x.roleTag===null).map((template)=>(
                              <div className="col-lg-12">
                              <p>
                              <a href="#" onClick={()=>this.viewTemplate(template,pentity)}> {template.templateName}</a>
                                <br/>{template.createdByUserName!=null && template.createdByUserName + ", "+ format(new Date(template.createdDate),"MM/dd/yyyy hh:mm")}
                              </p>
                              </div>
                            ))}
                        
                            </div>
                          </div>
                        </div>
                        }
                        {patient.templates !=null && patient.templates.filter(x=> x.roleTag==='Referral').length>0 &&
                        <div className="kt-section">
                          <h3>Referral</h3>
                          <div className="kt-section__content">
                            <div className="row">
                            
                            {patient.templates.filter(x=> x.roleTag==='Referral').map((template)=>(
                              <div className="col-lg-12">
                             <p>
                              <a href="#" onClick={()=>this.viewTemplate(template,pentity)}> {template.templateName}</a>
                                <br/>{template.createdByUserName!=null && template.createdByUserName + ", "+ format(new Date(template.createdDate),"MM/dd/yyyy hh:mm")}
                              </p>
                              </div>
                            ))}
                        
                            </div>
                          </div>
                        </div>
                        }
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="kt-portlet" id="kt_portlet">
                            <div className="kt-portlet__head">
                              <div className="kt-portlet__head-label">
                               
                                <h3 className="kt-portlet__head-title">
                                  Documents/Images
                                </h3>
                              </div>
                              <div className="kt-portlet__head-toolbar">
                                <div className="kt-portlet__head-group">
                                  <div className="btn-group">
                                    <button type="button" className="btn btn-elevate btn-danger" disabled={!this.state.patientSelected} onClick={ this.handleOpen } data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                      <i className="la la-plus"></i> Add Documents/Images
                                    </button>
                                    
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="kt-portlet__body">
                          
                              {patient.files !=null && patient.files.filter(x=> x.roleTag===null && x.parentFileId===null).length>0 &&
                        <div className="kt-section">
                          <h3>Practice</h3>
                          <div className="kt-section__content">
                            
                            <div className="row">
                            
                            {patient.files !=null && patient.files.filter(x=> x.roleTag===null && x.parentFileId===null).map((file)=>(
                              <div className="col-lg-12">
                              <Tooltip title={file.fileName}>
                                <a href="#" onClick={()=>this.imageView(patient.id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
                                  {file.fileType.includes("image") &&
                                    <S3Image id={patient.id} originalFileKey={file.thumbFileKey}/>
                                  }
                                  {!file.fileType.includes("image") &&
                                    <img src="media/icons/svg/Files/File.svg"/>
                                  }
                                  {patient.files.filter(x=> x.parentFileId===file.fileKey).length>0 && <AudiotrackIcon style={{ color: '#5867dd',fontSize: 12}}/>}
                                    
                                  {file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
                                  <br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}  
                                </a>
                              </Tooltip>
                              </div>
                            ))}
                            </div>
                            
                          </div>
                        </div>
                        }
                        {patient.files!=null && patient.files.filter(x=> x.roleTag==='Referral' && x.parentFileId===null).length>0 &&
                        <div className="kt-section">
                          <h3>Referral</h3>
                          <div className="kt-section__content">
                            
                            <div className="row">
                            
                            {patient.files!=null && patient.files.filter(x=> x.roleTag==='Referral' && x.parentFileId===null).map((file)=>(
                              <div className="col-lg-12">
                              <Tooltip title={file.fileName}>
                                <a href="#" onClick={()=>this.imageView(patient.id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
                                  {file.fileType.includes("image") &&
                                    <S3Image id={patient.id} originalFileKey={file.thumbFileKey}/>
                                  }
                                  {!file.fileType.includes("image") &&
                                    <img src="media/icons/svg/Files/File.svg"/>
                                  }
                                  {patient.files.filter(x=> x.parentFileId===file.fileKey).length>0 && <AudiotrackIcon style={{ color: '#5867dd',fontSize: 12}}/>}
                                    
                                  {file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
                                  <br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}   
                                </a>
                              </Tooltip>
                              </div>
                            ))}
                            </div>
                            
                          </div>
                        </div>
                        }
                            </div>
                          </div>
                        </div>
                          <div className="row">
                    <div className="col">
                    <div className="kt-portlet">
											<div className="kt-portlet__head">
												<div className="kt-portlet__head-label">
													{/*<span className="kt-portlet__head-icon">
														<i className="flaticon-map-location"></i>
													</span>*/}
													<h3 className="kt-portlet__head-title">
														Record Voice Notes
													</h3>
												</div>
											</div>
											<div className="kt-portlet__body">
											<Recorder
												record={true}
												
												audioURL={this.state.audioDetails.url}
												showUIAudio
												handleAudioStop={data => this.handleAudioStop(data)}
												handleOnChange={(value) => this.handleOnChange(value, 'firstname')}
												handleAudioUpload={data => this.handleAudioUpload(data)}
												handleReset={() => this.handleRest()} />
											</div>
										</div>
                    </div>
                  </div>
                        </div>
                        
                      </div>
                      <div className="kt-login__actions">
                          <button
                              onClick={this.send}
                              disabled={!this.state.patientSelected}
                              className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                                {
                                  "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                                }
                              )}`}
                             
                            >
                             Send
                          </button>
                      </div>
                      </>
                      }

                      {this.state.patientType!==null && this.state.patientType==="digitalplanning" && this.state.patientSelected===true &&  this.state.patients.length>0 &&
                        <div className="row">
                          <div className="col-lg-12">
                             <CodeExample beforeCodeTitle="Job Order">
                             <Formik
                                              initialValues={{
                                                accountId:"",
                                                pEntityId:"",
                                                notes:"",
                                                patientName: this.state.pentity.firstName + " " + this.state.pentity.lastName,
                                                pId: this.state.pentity.patientId,
                                                dob: this.state.pentity.dateOfBirth
                                             }}
                                              validate={values => {
                                                const errors = {};
                            
                                                console.log("formik va::::::",this.state.jobServiceTypeId,this.state.assignedToAccountKey);
                            
                                                if (this.state.jobServiceTypeId.length===0) {
                                                  errors.jobServiceTypeId = this.props.intl.formatMessage({
                                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                                  });
                                                }
                                                //else
                                                //  errors.jobServiceTypeId = false;
                                              
                            
                                            
                                                if (this.state.assignedToAccountKey===null ) {
                                                  errors.assignedToAccountKey = this.props.intl.formatMessage({
                                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                                  });
                                                }
                            
                                                if (this.state.deliveryDate===null ) {
                                                  errors.deliveryDate = this.props.intl.formatMessage({
                                                    id: "AUTH.VALIDATION.REQUIRED_FIELD"
                                                  });
                                                }
                                                //else
                                                //errors.assignedToAccountKey = false;
                            
                                                return errors;
                                              }}
                                              onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                            
                                               this.setState({loading:true});
                                             
                            
                                                      createJobRequest(
                                                        this.state.assignedToAccountKey,
                                                        this.state.pentity.pEntityId,
                                                        values.notes,
                                                        this.state.jobServiceTypeId,                   
                                                        this.state.deliveryDate  ,
                                                         values.locationKey,
                            this.state.extractionTop,
                            this.state.extractionBottom,
                            this.state.selTreatmentPlans,
                            this.state.implantTypes
                                                      )
                                                        .then(resp => {
                                                          const jobData = resp;
                                                          //console.log("digital planning:::",resp);

                                                          if(this.state.pentity.isActive===false && this.state.pentity.isDeleted===false)
                                                            {
                                                               
                                                                let updateObj = {
                                                                  isActive:true
                                                                };

                                                                //if(values.locationKey!=null && values.locationKey!=undefined) updateObj.locationKey = values.locationKey;
                                                                updateMaster('pentityupdate',this.state.pentity.pEntityId,updateObj)
                                                                .then((resp) =>{
                                                                  //console.log("digital planning1:::");
                                                                 var src = "?id="+jobData.data.split('|')[1]+"&key="+this.state.pentity.id;
                                                                  this.setState({redirect:true,search:src});
                                                                   
                                                                });

                                                                
                                                            }
                                                            else if(this.state.pentity.isActive===false && this.state.pentity.isDeleted===true)
                                                            {
                                                                retrieve(this.state.pentity.id)
                                                                .then((response) => {

                                                                 var src = "?id="+jobData.data.split('|')[1]+"&key="+this.state.pentity.id;
                                                                  this.setState({redirect:true,search:src});
                                                                
                                                                    
                                                                });
                                                            }
                                                            else
                                                            {
                                                             //console.log("digital planning3:::");
                                                             
                                                              var src = "?id="+jobData.data.split('|')[1]+"&key="+this.state.pentity.id;
                                                                  this.setState({redirect:true,search:src});   
                                                            }

                                   
                                                         
                                                        
                                                        })
                                                        .catch(() => {
                                                        
                                                          this.setState({loading:false,isSubmitting:false});
                                                        })
                                                      
                            
                                               
                                              }}
                                            >
                                              {({
                                                values,
                                                status,
                                                errors,
                                                touched,
                                                handleChange,
                                                handleBlur,
                                                handleSubmit,
                                                isSubmitting,
                                               
                                              }) => (
                                                <form onSubmit={handleSubmit} noValidate autoComplete="off">
                                                  
                                      
                                
                                      <div className="kt-section">
                                        <div className="kt-section__content">
                                        
                                        <div className="row">
                                                    <div className="col">
                                                      <TextField
                                                        margin="normal"
                                                        label="Patient Name"
                                                        className="kt-width-full"
                                                        name="patientName"
                                                        value={values.patientName}
                                                        InputProps={{
                                                          readOnly: true,
                                                        }}
                                                        variant="filled"
                                                        
                                                      />
                                                    </div>
                                                  </div>    
                            
                                                  <div className="row">
                                                    <div className="col">
                                                      <TextField
                                                        margin="normal"
                                                        label="PID"
                                                        className="kt-width-full"
                                                        name="pId"
                                                        value={values.pId}
                                                        InputProps={{
                                                          readOnly: true,
                                                        }}
                                                        variant="filled"
                                                      />
                                                    </div>
                                                  </div>    
                            
                                                  <div className="row">
                                                    <div className="col">
                                                      <TextField
                                                        margin="normal"
                                                        label="DOB"
                                                        className="kt-width-full"
                                                        name="dob"
                                                        value={values.dob}
                                                        InputProps={{
                                                          readOnly: true,
                                                        }}
                                                        variant="filled"
                                                      />
                                                    </div>
                                                  </div>    
                                     
                                         
                                                  <div className="row">
                                                   <div className="col">
                                                    <FormControl component="fieldset" className={classes.root} style={{'width':'100%'}}>
                                                      <FormLabel component="legend">Digital Planning Packages</FormLabel>
                                                       <FormGroup row={true}>
                                                          {this.state.jobServiceTypes.map((pt)=>(
                                                          <>
                                                          <FormControlLabel 
                                                            control={<Checkbox tyle={{ width: 'auto' }}  onChange={this.handleServiceChange} value={pt.jobServiceTypeId} name={'jobServiceTypeId'} color="primary"/>}
                                                            label={pt.serviceType}
                                                            
                                                          />
                                                          </>
                                                                                            
                                                          ))}
                                                       </FormGroup>
                                                       {Boolean(errors.jobServiceTypeId) &&
                                                       <FormHelperText id="b-text" error>This field is required</FormHelperText>
                                                        }
                                                     </FormControl>
                                                     </div>
                                                  </div>
                                                  <div className="row">
                                                    <div className="col">
                                                      <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                      <Grid container justify="space-around">
                                                      <KeyboardDatePicker
                                                            variant="inline"
                                                            format="MM/dd/yyyy"
                                                            margin="normal"
                                                            id="deliveryDate"
                                                            name="deliveryDate"
                                                            label="Surgery Date"
                                                            minDate = {new Date()}
                                                            value={this.state.deliveryDate}
                                                            onChange={value => {
                                                              this.setState({deliveryDate:value})
                                                            }}
                                                            KeyboardButtonProps={{
                                                              'aria-label': 'change date',
                                                            }}
                                                          />
                                                          
                                                      </Grid>
                                                       {Boolean(errors.deliveryDate) &&
                                                          <FormHelperText id="a-text" error>This field is required</FormHelperText>
                                                        }
                                                      </MuiPickersUtilsProvider>
                            
                                                    </div>
                                                  </div>
                            
                                                  <div className="row">
                                                    <div className="col">
                                                      <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                                         <Autocomplete
                                                           
                                                            id="assignedToAccountKey"
                                                            name="assignedToAccountKey"
                                                            options={this.state.labAccounts}
                                                            onChange={(event,newValue)=>this.handleAccountChange(event,newValue)}
                                                            onBlur={handleBlur}
                                                            value={values.assignedToAccountKey}
                                                            helperText={errors.assignedToAccountKey}
                                                            error={Boolean(errors.assignedToAccountKey)}
                                                            variant="outlined"
                                                            autoComplete={true}
                                                            clearOnBlur={true}
                                                            getOptionLabel={(option) => option.accountName}
                                                            renderInput={(params) => (
                                                                                           <TextField
                                                                                           {...params}
                                                                                               margin="normal"
                                                                                               label="Assign to Lab"
                                                                                              
                                                                                   />
                                                                                )}
                                                                               />
                                                        {Boolean(errors.jobServiceTypeId) &&
                                                          <FormHelperText id="a-text" error>This field is required</FormHelperText>
                                                        }
                                                     </FormControl>
                                                    </div>
                                                  </div>

                                                   <div className="row">
                                                    <div className="col">
                                                                                         <FormControl className={classes.formControl} style={{'width':'100%'}}>
                                                                                                  <InputLabel id="locationKey-label">Location</InputLabel>
                                                                                                     <Select
                                                                                                      labelId="locationKey-label"
                                                                                                      id="locationKey"
                                                                                                      margin="normal"
                                                                                                      name="locationKey"
                                                                                                      value={values.locationKey}
                                                                                                      //onChange={(e)=>{handleChange(e);this.setState({locationKey:e.target.value})}}
                                                                                                      onChange={handleChange}
                                                                                                      onBlur={handleBlur}
                                                                                                      className="kt-width-full"
                                                                                                      style={{'width':'100%'}}
                                                                                                    >
                                                                                                    <MenuItem value="">
                                                                                                        <em>None</em>
                                                                                                      </MenuItem>
                                                                                                      {this.state.locations.map((loc) =>(
                                                                        
                                                                                                      <MenuItem key={loc.locationKey} value={loc.locationKey}>{loc.locationName}</MenuItem>
                                                                                                      
                                                                                                      ))}
                                                                                                    </Select>
                                                                                                 </FormControl>
                                                                                                 </div>
                                                                                      </div>
                                                                        <div className="row">
                                                                                                <div className="col">
                                                                                             
                                                                                                                       <Autocomplete
                                                                                                                         multiple
                                                                                                                         id="tags-standard"
                                                                                                                         defaultValue={this.state.selectedVal}
                                                                                                                         options={this.state.implants}
                                                                                                                         onChange={this.onSelectTag}
                                                                                                                         style={{'width':'100%'}}
                                                                                                                         getOptionLabel={(option) => option.implantName }
                                                                                                                         renderInput={(params) => (
                                                                                                                                   <TextField style={{'width':'100%'}}
                                                                                                                                   {...params}
                                                                                                                           
                                                                                                                                                             margin="normal"
                                                                                                                                                             label="Implant Name"
                                                                                                                                                             
                                                                                                                                                           />
                                                                                             
                                                                                                                         )}
                                                                                                                       />
                                                                                                                       </div>       
                                                                                                                       </div>

                                                                                                                        {this.state.fieldGroups!=null && this.state.fieldGroups.map((field)=>(
                                                                                                                                             <>
                                                                                                                                             <div className="row">
                                                                                                                                               <div className="col">
                                                                                                                                                 {field.dataType === "checkboxgroupimage" &&
                                                                                                                                                
                                                                                                                                                          <div class="container" style={{'background-color':'#0B6CAF'}}>
                                                                                                                                                          {field.imagePosition === 'top' &&
                                                                                                                                                          <div className="row" style={{'border': '1px solid grey','width':'100%','background-color':field.background!==null && field.background=='white'? 'white':'#0B6CAF'}}>
                                                                                                                                                          <FormGroup row>
                                                                                                                                                            {field.imagePath.map((val,index)=>(
                                                                                                                                                              <div className="col" style={{'border': '1px solid grey','width':'63px'}}>
                                                                                                                                                               <FormControlLabel 
                                                                                                                                                                control={<Figure.Image
                                                                                                                                                                            alt="171x180"
                                                                                                                                                                    src={val}
                                                                                                                                                                  />}
                                                                                                                                                                style={{'margin-left': 'auto','margin-right':'auto'}} />
                                                                                                                       
                                                                                                                                                                <FormControlLabel 
                                                                                                                                                                control={<Checkbox style={{'margin-left':'0px','color':'white'}} onChange={this.handleCheckBoxChange} value={field.values[index]} name={'extractionTop'} fontSize="small" />}
                                                                                                                                                                label={field.values[index]} labelPlacement="end"  style={{'color':'white'}}
                                                                                                                       
                                                                                                                                                              />
                                                                                                                                                                  </div>
                                                                                                                                                                
                                                                                                                                                            
                                                                                                                                                           ))}
                                                                                                                                                          </FormGroup>
                                                                                                                                                          </div>
                                                                                                                                                        }
                                                                                                                                                         
                                                                                                                                                          {field.imagePosition === 'bottom' &&
                                                                                                                                                          <div className="row" style={{'border': '1px solid grey','width':'100%','background-color':field.background!==null && field.background=='white'? 'white':'#0B6CAF'}}>
                                                                                                                                                          <FormGroup row>
                                                                                                                                                            {field.imagePath.map((val,index)=>(
                                                                                                                                                              <div className="col" style={{'border': '1px solid grey','alignContent':'center', 'text-align': 'center','width':'63px'}}>
                                                                                                                                                                <FormControlLabel 
                                                                                                                                                                control={<Checkbox style={{'margin-left':'0px','color':'white'}} onChange={this.handleCheckBoxChange} value={field.values[index]} name={'extractionBottom'} fontSize="small" />}
                                                                                                                                                                label={field.values[index]} labelPlacement="end"  style={{'color':'white'}}
                                                                                                                       
                                                                                                                                                              />
                                                                                                                       
                                                                                                                                                            
                                                                                                                                                               <FormControlLabel 
                                                                                                                                                                control={<Figure.Image
                                                                                                                                                                            alt="171x180"
                                                                                                                                                                    src={val}
                                                                                                                                                                  />}
                                                                                                                                                                style={{'margin-left': 'auto','margin-right':'auto'}} />
                                                                                                                                                                  </div>
                                                                                                                                                                
                                                                                                                                                            
                                                                                                                                                           ))}
                                                                                                                                                          </FormGroup>
                                                                                                                                                          </div>
                                                                                                                                                        }
                                                                                                                       
                                                                                                                                                    
                                                                                                                       
                                                                                                                                                          </div>
                                                                                                                                                          
                                                                                                                                                     
                                                                                                                                                 }
                                                                                                                                               </div>
                                                                                                                                             </div>
                                                                                                                                             </>
                                                                                                                                            ))
                                                                                                                                             }
                                                                                                                                              <div className="row">
                                                                                                                                                                       <div className="col">       
                                                                                                                                                                   
                                                                                                                                                                                             <Autocomplete
                                                                                                                                                                                               multiple
                                                                                                                                                                                               id="tags-standard"
                                                                                                                                                                                               defaultValue={this.state.selectedPlan}
                                                                                                                                                                                               options={this.state.treatmentPlans}
                                                                                                                                                                                               onChange={this.onSelectPlan}
                                                                                                                                                                                               style={{'width':'100%'}}
                                                                                                                                                                                               getOptionLabel={(option) => option.treatmentPlanName }
                                                                                                                                                                                               renderInput={(params) => (
                                                                                                                                                                                                         <TextField style={{'width':'100%'}}
                                                                                                                                                                                                         {...params}
                                                                                                                                                                                                 
                                                                                                                                                                                                                                   margin="normal"
                                                                                                                                                                                                                                   label="Treatment Recommendations"
                                                                                                                                                                                                                                   
                                                                                                                                                                                                                                 />
                                                                                                                                                                   
                                                                                                                                                                                               )}
                                                                                                                                                                                             />
                                                                                                                                                                                             </div>
                                                                                                                                                                                  
                                                                                                                                                                                 </div>
                                                 
                                                 <div className="row">
                                                    <div className="col">
                                                      <TextField
                                                        margin="normal"
                                                        label="Tooth # / Notes"
                                                        className="kt-width-full"
                                                        name="notes"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.notes}
                                                        helperText={touched.notes && errors.notes}
                                                        error={Boolean(touched.notes && errors.notes)}
                                                        variant="outlined"
                                                        multiline
                                                        maxRows={4}
                                                      />
                                                    </div>
                                                  </div>    
                                                  
                                         
                                          
                            
                                          
                                       
                                          <div className="row">
                                            <div className="col">
                                                <button
                                                     disabled={isSubmitting}
                                                     type="submit"
                                                        className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                                                          {
                                                            "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                                                          }
                                                        )}`}
                                                       
                                                      >
                                                      Confirm & Order
                                                    </button>
                                            </div>
                                          </div>
                                       
                                          
                                          
                                    </div>
                                    </div>
                                    
                               
                            
                                    </form>
                                        )}
                                        </Formik>
                            </CodeExample>
                          </div>
                        </div>
                       

                      }


                      </>
                    ))}
              
            
              <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
 
                    <DialogTitle id="form-dialog-title">Drag & Drop documents/images to upload</DialogTitle>
                    <DialogContent>
                     
                      <Dropzone
                        accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.mp3,.zip,.stl"
                        PreviewComponent={(props) => (
										<FileUploadPreview
										{...props}
										customStatus={this.state.statusMap[props.meta.id]}
										/>)}
                        onChangeStatus={this.handleChangeStatus}
                    getUploadParams={this.getUploadParams}
                    styles={{ dropzone: { minHeight: 200, maxHeight: 250 } }}
                   />
                    </DialogContent>
      

                    <DialogActions>
                      <Button onClick={this.handleClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>

                  <Dialog open={this.state.imageOpen} onClose={this.imageClose} aria-labelledby="form-dialog-title">
 
                    <DialogTitle id="form-dialog-title">Document/Image Viewer</DialogTitle>
                    <DialogContent>
                      {this.state.fileType!=null && this.state.fileType.includes("image") &&
                      <Figure>
                          <Figure.Image
                            
                            alt="171x180"
                            src={this.state.imageUrl}
                          />
              
                      </Figure>
                    }
                       {this.state.fileType!=null && this.state.fileType.includes("audio") &&
                              <ReactAudioPlayer
                  src={this.state.imageUrl}
                  autoPlay
                  controls
                />

                            }
                             {this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag===null && x.parentFileId===this.state.id).length>0 &&
                        <div className="kt-section">
                          <h3>Practice</h3>
                          <div className="kt-section__content">
                            
                            <div className="row">
                            
                            {this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag===null && x.parentFileId===this.state.id).map((file)=>{
                               if(file.fileType.includes("audio")) 
                               { return (<div className="col-lg-12">
                                 
                                 <Tooltip title={file.fileName}>
                                   <a href="#" onClick={()=>this.audioView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
                                       <img src="media/icons/svg/Files/Music.svg"/>
                                     {file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
                                     <br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
                                   </a>
                                 </Tooltip>
                                 {this.state.audioUrl!=null && this.state.audioKey !==null && this.state.audioKey===file.fileKey &&
                                                  <ReactAudioPlayer
                                     src={this.state.audioUrl}
                                     autoPlay
                                     controls
                                   />
 
                                               }
                                 
                               </div>
                               )}
                               else if (file.fileType.includes("video"))
                               {return (
                               <div className="col-lg-12">
                                 
                                 <Tooltip title={file.fileName}>
                                   <a href="#" onClick={()=>this.videoView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
                                       <img src="media/icons/svg/Files/Media.svg"/>
                                     {file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
                                     <br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
                                   </a>
                                 </Tooltip>
                                 
                                 
                               </div>
                               )}
                               })}
                            </div>
                            
                          </div>
                        </div>
                        }
                         {this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag==='Referral' && x.parentFileId===this.state.id).length>0 &&
                        <div className="kt-section">
                          <h3>Practice</h3>
                          <div className="kt-section__content">
                            
                            <div className="row">
                            
                            {this.state.patients !==null && this.state.patients.length>0 && this.state.patients[0].files !=null && this.state.patients[0].files.filter(x=> x.roleTag==='Referral' && x.parentFileId===this.state.id).map((file)=>{
                              if(file.fileType.includes("audio")) 
															{ return (<div className="col-lg-12">
																
																<Tooltip title={file.fileName}>
																	<a href="#" onClick={()=>this.audioView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																			<img src="media/icons/svg/Files/Music.svg"/>
																		{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																		<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																	</a>
																</Tooltip>
																{this.state.audioUrl!=null && this.state.audioKey !==null && this.state.audioKey===file.fileKey &&
	                           										<ReactAudioPlayer
																	  src={this.state.audioUrl}
																	  autoPlay
																	  controls
																	/>

                            									}
																
															</div>
															)}
															else if (file.fileType.includes("video"))
															{return (
															<div className="col-lg-12">
																
																<Tooltip title={file.fileName}>
																	<a href="#" onClick={()=>this.videoView(this.state.patients[0].id,file.previewFileKey,file.fileKey,file.originalFileKey,file.fileType)} className="kt-media kt-media--circle">
																			<img src="media/icons/svg/Files/Media.svg"/>
																		{file.fileName.length<36 ? file.fileName : file.fileName.substring(0,36) + "..."}
																		<br/>{file.createdByUserName!=null && file.createdByUserName + ", "+ format(new Date(file.createdDate),"MM/dd/yyyy hh:mm")}
																	</a>
																</Tooltip>
																
																
															</div>
															)}
                            })}
                            </div>
                            
                          </div>
                        </div>
                        }
                    </DialogContent>
      

                    <DialogActions>
                    {/*this.state.fileType!=null && this.state.fileType.includes("image") &&
                    <Button onClick={()=>this.setState({videoRecord:true})} color="primary">
                        Record Screen
                      </Button>
                      */}
                   {this.state.fileType!=null && this.state.fileType.includes("image") &&
                      			<ReactMediaRecorder
											      screen audio
											      render={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
											        <div>
											          {status==="idle"  && 
											          <Tooltip title="Record Screen"><MusicVideoIcon style={{ color: '#5867dd',fontSize: 35}} onClick={startRecording}/></Tooltip>
											        	}													   
													   
											          {status==="recording" &&
													  
											          <Tooltip title="Stop Recording"><StopIcon style={{ color: '#5867dd',fontSize: 35}} onClick={stopRecording}/></Tooltip>
											        	}
											        	{status === "stopped111" &&
											          <Tooltip title="Preview Recording"><Button onClick={()=>this.setState({videoOpen:true,mediaBlobUrl:mediaBlobUrl})}>Preview</Button></Tooltip>
											          }
											          {status === "stopped" && this.state.videoDetails ===false && this.state.uploadComplete===false &&
											          <Tooltip title="Upload Recording"><Button onClick={()=>this.uploadVideo(mediaBlobUrl)}>
														  Save Recording</Button></Tooltip>
											          }
													  {status === "stopped" && this.state.videoDetails ===true && 
											          <CircularProgress/>
											          }
													  
											        </div>
											      )}
											    />
                      					}





                      {this.state.fileType!=null && this.state.fileType.includes("image") &&
                    <Button onClick={()=>this.setState({audioOpen:true})} color="primary">
                        Record
                      </Button>
                  }
                      <Button onClick={this.imageClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>
                  <Draggable>
                  <Dialog open={this.state.audioOpen} onClose={this.audioClose} aria-labelledby="form-dialog-title">
 
                    <DialogTitle id="form-dialog-title" style={{ cursor: 'move' }}>Voice Recorder</DialogTitle>
                    <DialogContent>
                    <Recorder
                        record={true}
                        audioURL={this.state.audioDetails.url}
                        showUIAudio
                        handleAudioStop={data => this.handleAudioStop(data)}
                        handleOnChange={(value) => this.handleOnChange(value, 'firstname')}
                        handleAudioUpload={data => this.handleAudioUpload(data)}
                        handleReset={() => this.handleRest()} />
                    </DialogContent>
      

                    <DialogActions>
                      <Button onClick={this.audioClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>
                  </Draggable>

                  <Draggable>

							  <Dialog open={this.state.videoRecord} aria-labelledby="vrecord-dialog-title" maxWidth="sm">
 
						        <DialogTitle id="vrecord-dialog-title" style={{ cursor: 'move' }}>Screen Recorder</DialogTitle>
						        <DialogContent>
						        <ReactMediaRecorder
											      screen audio
											      render={({ status, startRecording, stopRecording, mediaBlobUrl }) => (
											        <div>
											          
											          {status==="idle" &&
											          <Tooltip title="Record Screen"><MusicVideoIcon style={{ color: '#5867dd',fontSize: 35}} onClick={startRecording}/></Tooltip>
											        	}
											          {status==="recording" &&
													  <>
											          <Tooltip title="Stop Recording"><StopIcon style={{ color: '#5867dd',fontSize: 35}} onClick={stopRecording}/></Tooltip> &nbsp; Recording...</>
											        	}
											        	{status === "stopped" &&
											          <Tooltip title="Preview Recording"><Button onClick={()=>this.setState({videoOpen:true,mediaBlobUrl:mediaBlobUrl})}>Preview</Button></Tooltip>
											          }
											          {status === "stopped" && 
											          <Tooltip title="Upload Recording"><Button onClick={()=>this.uploadVideo(mediaBlobUrl)}>Upload</Button></Tooltip>
											          }
											        </div>
											      )}
											    />
						        </DialogContent>
      

						        <DialogActions>
						          <Button onClick={this.vRecordClose} color="primary">
						            Close
						          </Button>
						          
						        </DialogActions>
      
      						</Dialog>
							  </Draggable>

                <Dialog open={this.state.videoOpen} aria-labelledby="video-dialog-title" maxWidth="sm">
 
                <DialogTitle id="video-dialog-title" style={{ cursor: 'move' }}>Video Viewer</DialogTitle>
                <DialogContent>
                    <video src={this.state.mediaBlobUrl} style={{width:'100%',height:'auto'}} controls />
                </DialogContent>


                <DialogActions>
                  <Button onClick={this.videoClose} color="primary">
                    Close
                  </Button>
                  
                </DialogActions>

                </Dialog>

                  <Dialog open={this.state.duplicateOpen} onClose={this.duplicateClose} aria-labelledby="form-dialog-title">
 
                    <DialogTitle id="form-dialog-title">Duplicate Patient Record(s) (First Name, Last Name and DOB)</DialogTitle>
                    <DialogContent>
                      <Table striped bordered hover>
                         <thead>
                          <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>DOB</th>
                            <th>Mobile</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.duplicatePatients.map((patient)=>(
                          <tr >
                               
                                <td>{patient.firstName}</td>
                                <td>{patient.lastName}</td>
                                <td>{patient.dateOfBirth}</td>
                                <td>{patient.mobile}</td>
                                <td>
                                  <Button onClick={()=>this.selectPatient(patient)} color="primary">
                                    Select
                                  </Button>
                                </td>
                          </tr>


                        ))}
                        </tbody>
                    </Table>
                      
                    </DialogContent>
      

                    <DialogActions>
                      <Button onClick={this.duplicateClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>
                  {this.state.addtemTemplate!==null && this.state.addtemTemplate!==undefined &&
                  <Dialog open={this.state.addTemplateOpen}  aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth={true}>
 
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent>
                      
                      <AddTemplateData data={{template:this.state.addtemTemplate,patient:this.state.addtemPatient,fromPath:'/createpatient'}} />

                    </DialogContent>
      

                    <DialogActions style={{justifyContent: 'flex-start'}}>
                      <Button onClick={this.addTemplateClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>
                  }

              {this.state.viewtemTemplate!==null && this.state.viewtemTemplate!==undefined &&
                  <Dialog open={this.state.viewTemplateOpen}  aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth={true}>
 
                    <DialogTitle id="form-dialog-title"></DialogTitle>
                    <DialogContent>
                      
                      <ViewTemplateData data={{template:this.state.viewtemTemplate,patient:this.state.viewtemPatient,fromPath:'/createpatient'}} />

                    </DialogContent>
      

                    <DialogActions style={{justifyContent: 'flex-start'}}>
                      <Button onClick={this.viewTemplateClose} color="primary">
                        Close
                      </Button>
                      
                    </DialogActions>
      
                  </Dialog>
                  }

                  
       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(CreatePatient));

